"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initialState = void 0;
var ui_symbols_1 = require("@hopin-team/ui-symbols");
var initialState = function () {
    return ({
        isThemeLoaded: false,
        currentTheme: ui_symbols_1.rcTheme,
        fontUrls: {
            // TODO @AkimaLunar Include hopin fonts’ CDN links here 👇
            textFontUrl: 'https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap',
            // displayFontUrl: 'Larsseit',
        },
    });
};
exports.initialState = initialState;
//# sourceMappingURL=themeState.js.map